import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function Register() {
  const { t } = useTranslation();

  return (
  <div><main className="page-content">
    <div className="tm-section-two1 tm-section-menphoto wishlist-section-ones">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 center-box">
            <div className="login-logo">
              <h4><a href="index.html">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" /></svg>
                </a></h4>
              <a href="index.html" className="tm-header-logo"><img src="assets/images/logo.png" alt="Jewelry-Demo" /></a>
            </div>
            <form action="#" className="tm-form tm-login-form login-text center-box1">
              <h4>{t("R1")}</h4>
              <p>{t("R3")}</p>
              <div className="tm-form-inner">
                <div className="tm-form-field tm-form-field1 neme-text">
                  <label htmlFor="login-email">{t("R4")}</label>
                  <input type="email" id="login-password" required="required" />
                </div>
                <div className="tm-form-field neme-text">
                  <label htmlFor="login-password">{t("R5")}</label>
                  <input type="password" id="login-password" required="required" />
                </div>
                <div className="tm-form-field neme-text">
                  <label htmlFor="login-password">{t("R6")}</label>
                  <input type="password" id="login-password" required="required" />
                </div>
                <div className="tm-form-field tm-form-font">
                  <div>
                    <input type="checkbox" id="register-pass-show" name="register-pass-show" />
                    <label htmlFor="register-pass-show">{t("R7")}</label>
                  </div>
                  {/* <div>
                    <input type="checkbox" id="register-terms" name="register-terms" />
                    <label htmlFor="register-terms">{t("R8")} <a href="terms.html">{t("R9")}</a></label>
                  </div> */}
                </div>
                <div className="tm-form-field">
                  <button type="submit" className="tm-button tm-button-one">{t("R10")}</button>
                </div>
                {/* <div class="tm-form-field">
                          <div class="tm-form-sociallogin">
                              <h6>Or, Login with :</h6>
                              <ul>
                                  <li><a href="#" class="facebook-btn"><i class="ion-social-facebook"></i></a></li>
                                  <li><a href="#" class="google-btn"><i class="ion-social-google"></i></a></li>
                              </ul>
                          </div>
                      </div> */}
              </div>
            </form>
            <div className="login-footer">
              <div className="login-first">
                <h6>{t("R11")}<Link to ="/login" style={{fontWeight: 'bold'}}>{t("R12")}</Link></h6>
              </div>
              {/* <div class="create-account-text">
                      <a href="register.html">Create your account</a>
                  </div> */}
              <div className="create-account-text1">
                <ul>
                  {/* <li><a href="terms.html">Terms & Conditions</a></li> */}
                  {/* <li><a href="privacy.html">Privacy & Policy</a></li>
                          <li><a href="refunds.html">Refunds</a></li> */}
                </ul>
                <p className="tm-footer-copyright1">{t("R13")} <a href="https://www.revaconsultants.com/">{t("R14")} </a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main></div>

  )
}

export default Register